import type { HeurekaWidgetOptions } from '~~/types/components/Heureka/HeurekaWidgetOptions';
import { Logger } from '~~/helpers/logger';

const HEUREKA_SCRIPT_ID = 'heureka-widget-script';

export function loadHeurekaWidget(options: HeurekaWidgetOptions): void {

  if (typeof window === 'undefined') {

    return;

  }

  const { setKey, pushParams, scriptSrc } = options;

  window._hwq = window._hwq || [];
  window._hwq.push(['setKey', setKey]);
  window._hwq.push(pushParams);

  const existingScript = document.getElementById(HEUREKA_SCRIPT_ID);

  if (existingScript) {

    return;

  }

  const script = document.createElement('script');

  script.id = HEUREKA_SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = scriptSrc;

  script.onerror = (event) => {

    Logger.error('Failed to load Heureka widget: ', {
      scriptSrc,
      event,
    });

  };

  document.head.appendChild(script);

}
